import HeroButton from "../Heros/HeroButton";
import HeroDescription from "../Heros/HeroDescription";
import HeroTitle from "../Heros/HeroTitle";
import SectionText from "../Section/SectionText";
import Section3Root from "./SectionRoot";

export const Section3 = {
    Root: Section3Root,
    Title: HeroTitle,
    Button: HeroButton,
    Description: HeroDescription,
    Text: SectionText
}